import React from "react";
import TankLevel from "./tank_level.jsx";
import { withTranslation, Trans } from 'react-i18next';
import * as styles from "../tanks.module.scss";

class TankListView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const tank = this.props.item;
        return (
            <div className={styles.tank_view_item}>
                <div>
                    <div className={styles.tank_header}>{tank.tankName}</div>
                    <TankLevel
                        minLevel={tank.minLevel}
                        maxLevel={tank.maxLevel}
                        level={tank.volume}
                        width="140"
                        height="200"/>
                </div>
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td><div><Trans>Tanks.balance</Trans><span>:</span></div></td>
                                <td><div>{tank.volume && tank.volume.toFixed(2)}</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default withTranslation('translantions')(TankListView)